// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3k20D","content":"styles_content__1GUcx","selectAll":"styles_selectAll__1jMHD"};